import { Injectable, Inject } from '@angular/core';
import { DateTime } from 'luxon';
import { environment } from '@env/environment';
import { AuthStorageService } from '@auth-n/state/auth-storage.service';
import { CookieService } from '@utils/cookie.service';
import { ILoggingService, LOGGING_SERVICE_TOKEN } from '@logging/logging.token';

const TIMEOUT = 2 * 60 * 60; // 7200 seconds

@Injectable({ providedIn: 'root' })
export class AbandonmentService {
  private readonly storageKey = 'Abandonment:lastBecameActive';
  private readonly cookieName = 'amaryllis_to';

  constructor(
    @Inject(LOGGING_SERVICE_TOKEN) private logger: ILoggingService,
    private authStorageService: AuthStorageService,
    private cookieService: CookieService
  ) {}

  isAbandoned(): boolean {
    const storedData = this.authStorageService.getLocalStorage(this.storageKey);
    const cookieData = this.cookieService.getCookieValue(this.cookieName);
    let deltaSeconds = 0;

    if (!storedData && !cookieData) {
      this.logger.trace('Abandonment:', 'No stored data found');
      return false;
    }

    const nowMilli = DateTime.utc().toMillis();

    if (storedData) {
      const browseAway = JSON.parse(storedData) as BrowseAwayData;
      const delta = nowMilli - browseAway.timestamp;
      deltaSeconds = delta / 1000;
      if (deltaSeconds < TIMEOUT) return false;
    }

    if (cookieData) {
      const cookieTimestamp = DateTime.fromMillis(parseInt(cookieData, 10)).minus({ hours: 2 }).toMillis();
      const delta = nowMilli - cookieTimestamp;
      deltaSeconds = delta / 1000;
      if (deltaSeconds < TIMEOUT) return false;
    }

    this.logger.trace('Abandonment: difference between stored time and now (seconds)', deltaSeconds, 'configured limit:', TIMEOUT);
    return true;
  }

  setLastBecameActive(): void {
    const now = DateTime.utc();
    this.cookieService.setDomainCookie(this.cookieName, now.plus({ hours: 2 }).toMillis().toString(), environment.cookieDomain);
    this.authStorageService.setLocalStorage(this.storageKey, JSON.stringify(new BrowseAwayData(now.toMillis())));
  }
}

export class BrowseAwayData {
  constructor(public timestamp: number) {}
}
